export default "__VITE_ASSET__CfuHr2C0__"